import React from 'react';
import { Link } from 'react-router-dom';
interface ProductCardProps {
  product: {
    id: string;
    name: string;
    brand: string;
    image: string;
    startingPrice: number;
  };
}
export const ProductCard = ({
  product
}: ProductCardProps) => {
  return <Link to={`/product/${product.id}`} className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow" data-id="element-1206">
      <div className="p-4" data-id="element-1207">
        <div className="text-right text-sm text-gray-500 mb-2" data-id="element-1208">
          {product.brand}
        </div>
        <div className="h-48 flex items-center justify-center mb-4" data-id="element-1209">
          <img src={product.image} alt={product.name} className="h-full object-contain" data-id="element-1210" />
        </div>
        <h3 className="text-lg font-medium text-gray-800" data-id="element-1211">{product.name}</h3>
        <div className="mt-2 text-blue-600 font-medium" data-id="element-1212">
          From ${product.startingPrice}
        </div>
      </div>
    </Link>;
};